import React from 'react';
import Accordion from 'react-bootstrap/Accordion';

/* Components */
import Filter from './filter/Filter';
import FilterCollapse from './filter/FilterCollapse';

/* Utilities */
import { trans } from 'js/utilities';

export default class VehicleOverviewFilter extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { id = 'filter', filters, useConversionVehicleList } = this.props;

        const visibleFilters = filters.filter((filter) => filter.key !== 'partnervoertuig');

        return (
            <div className="row row--bordered gutters-4 vehicle--filter pb-6">
                {visibleFilters.map((filterGroup) => {
                    const filterGroupPath = `${filters?.indexOf(filterGroup)}`;
                    const filterGroupKey = filterGroup.key === 'price' && useConversionVehicleList ? 'price_incl_conversion' : filterGroup.key;

                    return (
                        <div key={filterGroupPath} className="col-12">
                            <Accordion defaultActiveKey={filterGroup.options.length == 0 ? filterGroupPath : null} bsPrefix="collapses">
                                <FilterCollapse
                                    eventKey={filterGroupPath}
                                    transKey={filterGroupKey}
                                    title={trans(`webstores_voertuigen_voorraad.filter.${filterGroupKey}`, {}, filterGroup.name?.replace(filterGroup.key, '')?.trim())}
                                >
                                    <div className="pt-1">
                                        <Filter
                                            id={`${id}.${filterGroupPath}`}
                                            path={filterGroupPath}
                                            filters={filterGroup.filters}
                                        />
                                    </div>
                                </FilterCollapse>
                            </Accordion>
                        </div>
                    );
                })}
            </div>
        );
    }
}
